(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-shop-tab"]) return;
  try {
    

  document.querySelectorAll('.tab').forEach(tab => {
    tab.addEventListener('click', function () {
      // Remove active class from all tabs
      document.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));

      // Add active class to clicked tab
      this.classList.add('active');

      // Scroll to the section
      const sectionId = this.getAttribute('data-target');
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

const toggleBtn = document.getElementById('sortingToggle');

  toggleBtn.addEventListener('click', function () {
    if (window.innerWidth <= 768) {
      document.querySelectorAll('.tab').forEach(tab => {
        tab.classList.toggle('tab-vis');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rokhz-waitlist"] && !Shopify.designMode) return;
  try {
    
  // Flodesk is the primary destination for this waitlist.
  // The visible ROKHZ fields are mirrored into the hidden Flodesk form as the
  // visitor types/selects them. Clicking Join the waitlist submits the hidden
  // Flodesk form first. Shopify saving, when enabled, happens only after
  // Flodesk reports a successful submission.
  (function () {
    function visible(el) {
      return !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
    }

    function describe(el) {
      var parts = [
        el.name || '',
        el.id || '',
        el.placeholder || '',
        el.getAttribute('aria-label') || ''
      ];

      if (el.labels && el.labels.length) {
        Array.prototype.forEach.call(el.labels, function (label) {
          parts.push(label.textContent || '');
        });
      }

      var wrappingLabel = el.closest ? el.closest('label') : null;
      if (wrappingLabel) parts.push(wrappingLabel.textContent || '');

      return parts.join(' ').toLowerCase();
    }

    function setNativeValue(el, value) {
      if (!el) return;

      if (el.tagName === 'SELECT') {
        var wanted = String(value).replace(/\s/g, '').toLowerCase();
        var wantedNoEu = wanted.replace(/^eu/, '');
        var matched = false;

        for (var i = 0; i < el.options.length; i++) {
          var optionText = (el.options[i].value + ' ' + el.options[i].text)
            .replace(/\s/g, '')
            .toLowerCase();

          if (optionText.indexOf(wanted) !== -1 || optionText.indexOf(wantedNoEu) !== -1) {
            el.selectedIndex = i;
            matched = true;
            break;
          }
        }

        if (!matched) el.value = value;
      } else if (el.type === 'radio' || el.type === 'checkbox') {
        var ownValue = String(el.value || '').replace(/\s/g, '').toLowerCase();
        var targetValue = String(value).replace(/\s/g, '').toLowerCase();
        var targetNoEu = targetValue.replace(/^eu/, '');
        el.checked = ownValue.indexOf(targetValue) !== -1 || ownValue.indexOf(targetNoEu) !== -1;
      } else {
        var proto = el.tagName === 'TEXTAREA' ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
        var descriptor = Object.getOwnPropertyDescriptor(proto, 'value');
        if (descriptor && descriptor.set) descriptor.set.call(el, value);
        else el.value = value;
      }

      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function findFlodeskForm(box) {
      if (!box) return null;
      var form = box.querySelector('form');
      if (!form) return null;

      var email = form.querySelector('input[type="email"], input[name="email"], input[name*="email" i]');
      return email ? { form: form, email: email } : null;
    }

    function waitFor(fn, ms) {
      return new Promise(function (resolve) {
        var start = Date.now();
        (function check() {
          var result = fn();
          if (result || Date.now() - start > ms) return resolve(result || null);
          setTimeout(check, 150);
        })();
      });
    }

    function ensureFlodeskForm(root, box) {
      return waitFor(function () {
        var existing = findFlodeskForm(box);
        if (existing) return existing;

        if (typeof window.fd === 'function' && box.dataset.fdMountStarted !== 'true') {
          box.dataset.fdMountStarted = 'true';
          try {
            window.fd('form', {
              formId: root.dataset.flodeskId,
              containerEl: '#' + box.id
            });
          } catch (error) {
            box.dataset.fdMountStarted = 'false';
            console.error('ROKHZ waitlist: could not mount Flodesk form.', error);
          }
        }

        return findFlodeskForm(box);
      }, 10000);
    }

    function getVisibleValues(form) {
      var emailInput = form.querySelector('input[name="contact[email]"]');
      var sizeInput = form.querySelector('input[name="contact[tags]"]:checked');

      return {
        email: emailInput ? emailInput.value.trim() : '',
        size: sizeInput ? sizeInput.dataset.size : ''
      };
    }

    function findSizeFields(fdForm) {
      return Array.prototype.filter.call(
        fdForm.querySelectorAll('input:not([type="hidden"]):not([type="submit"]), select, textarea'),
        function (el) {
          return el.type !== 'email' && /shoe\s*size|size/.test(describe(el));
        }
      );
    }

    function syncToFlodesk(visibleForm, fd) {
      if (!fd) return false;

      var values = getVisibleValues(visibleForm);
      if (values.email) setNativeValue(fd.email, values.email);

      var sizeFields = findSizeFields(fd.form);
      if (values.size && sizeFields.length) {
        sizeFields.forEach(function (field) {
          setNativeValue(field, values.size);
        });
      }

      if (values.size && !sizeFields.length) {
        console.warn('ROKHZ waitlist: Flodesk Shoe size field was not found in the embedded form.');
      }

      return true;
    }

    function flodeskOutcome(box, email) {
      var ok = box.querySelector('[data-ff-stage="success"], .fd-form-success, [class*="__success"]');
      if (visible(ok) || !visible(email)) return 'success';

      var bad = box.querySelector('[data-ff-stage="error"], .fd-form-error, [class*="__error"], .fd-has-error, .fd-form-feedback');
      if (visible(bad) && bad.textContent.trim()) return 'error';

      return null;
    }

    function showMessage(form, text, isError, eyebrow, note) {
      var old = form.querySelector('.rz-wl__message');
      if (old) old.remove();

      var p = document.createElement(isError ? 'p' : 'div');
      p.className = 'rz-wl__message ' + (isError ? 'rz-wl__message--error' : 'rz-wl__message--success');
      p.setAttribute('role', isError ? 'alert' : 'status');
      p.tabIndex = -1;

      if (isError) {
        p.textContent = text;
      } else {
        [
          ['rz-wl__done-eyebrow', eyebrow],
          ['rz-wl__done-text', text],
          ['rz-wl__done-note', note]
        ].forEach(function (line) {
          if (!line[1]) return;
          var el = document.createElement('p');
          el.className = line[0];
          el.textContent = line[1];
          p.appendChild(el);
        });
      }

      if (isError) {
        form.insertBefore(p, form.firstChild);
      } else {
        form.innerHTML = '';
        form.appendChild(p);
      }

      p.focus();
    }

    // Saves the sign-up in Shopify admin > Customers, tagged with the
    // waitlist tag and the size. keepalive lets it finish even if the
    // visitor leaves the page straight away.
    function saveToShopify(form) {
      if (form._rzShopifySave) return form._rzShopifySave;
      form._rzShopifySave = fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        keepalive: true
      }).then(function (response) {
        if (!response.ok || /\/challenge/.test(response.url || '')) {
          form._rzShopifySave = null;
          console.error('ROKHZ waitlist: Shopify Customers did not save this sign-up.');
        }
        return response;
      }).catch(function (error) {
        form._rzShopifySave = null;
        console.error('ROKHZ waitlist: Shopify Customers did not save this sign-up.', error);
        throw error;
      });
      return form._rzShopifySave;
    }

    function init(root) {
      var form = root.querySelector('form.rz-wl__form');
      var box = root.querySelector('.rz-wl__fd');
      if (!form || !box || form.dataset.fdReady) return;

      form.dataset.fdReady = 'true';

      var successText = root.dataset.successMessage;
      var successEyebrow = root.dataset.successEyebrow;
      var successNote = root.dataset.successNote;
      var emailInput = form.querySelector('input[name="contact[email]"]');
      var sizeInputs = form.querySelectorAll('input[name="contact[tags]"]');
      var mountedFd = null;

      // Mount the exact Flodesk form configured on this section as soon as
      // possible, even if the Flodesk header script becomes available later.
      ensureFlodeskForm(root, box).then(function (fd) {
        mountedFd = fd;
        if (fd) syncToFlodesk(form, fd);
      });

      // Mirror the visible values into the hidden Flodesk form before submit.
      if (emailInput) {
        emailInput.addEventListener('input', function () {
          if (mountedFd) syncToFlodesk(form, mountedFd);
        });
      }

      Array.prototype.forEach.call(sizeInputs, function (input) {
        input.addEventListener('change', function () {
          if (mountedFd) syncToFlodesk(form, mountedFd);
        });
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (form.classList.contains('is-sending')) return;

        if (form.reportValidity && !form.reportValidity()) return;

        form.classList.add('is-sending');
        form.setAttribute('aria-busy', 'true');

        // Shopify Customers copy starts straight away, alongside Flodesk,
        // so it is saved whatever happens with Flodesk.
        if (root.dataset.saveShopify === 'true') saveToShopify(form).catch(function () {});

        // Backup: if Flodesk does not load or confirm, the sign-up is saved
        // in Shopify admin > Customers (tagged with the waitlist tag and the
        // size), so no sign-up is lost.
        function keepInShopify() {
          saveToShopify(form).then(function (response) {
            form.classList.remove('is-sending');
            form.removeAttribute('aria-busy');
            if (response.ok) showMessage(form, root.dataset.backupMessage || successText, false);
            else showMessage(form, root.dataset.errorMessage, true);
          }).catch(function () {
            form.classList.remove('is-sending');
            form.removeAttribute('aria-busy');
            showMessage(form, root.dataset.errorMessage, true);
          });
        }

        ensureFlodeskForm(root, box).then(function (fd) {
          mountedFd = fd;

          if (!fd) {
            console.error('ROKHZ waitlist: Flodesk form did not load. Saved in Shopify Customers instead.');
            keepInShopify();
            return;
          }

          syncToFlodesk(form, fd);

          var button = fd.form.querySelector('button[type="submit"], input[type="submit"], [type="submit"]');
          if (button) button.click();
          else if (fd.form.requestSubmit) fd.form.requestSubmit();
          else fd.form.submit();

          waitFor(function () {
            return flodeskOutcome(box, fd.email);
          }, 15000).then(function (outcome) {
            if (outcome === 'success') {
              form.classList.remove('is-sending');
              form.removeAttribute('aria-busy');
              showMessage(form, successText, false, successEyebrow, successNote);
            } else {
              console.error('ROKHZ waitlist: Flodesk did not confirm. Saved in Shopify Customers instead.');
              keepInShopify();
            }
          });
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-rz-waitlist][data-flodesk-id]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
